/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateDomainRequestBody = {
  /**
   * Replacement IP allowlist. Pass an empty list to remove all restrictions.
   */
  ipAllowlist?: Array<string> | undefined;
  /**
   * Replacement OpenAI app-submission verification token. Pass an empty string to clear it.
   */
  openaiAppsChallengeToken?: string | undefined;
};

/** @internal */
export type UpdateDomainRequestBody$Outbound = {
  ip_allowlist?: Array<string> | undefined;
  openai_apps_challenge_token?: string | undefined;
};

/** @internal */
export const UpdateDomainRequestBody$outboundSchema: z.ZodMiniType<
  UpdateDomainRequestBody$Outbound,
  UpdateDomainRequestBody
> = z.pipe(
  z.object({
    ipAllowlist: z.optional(z.array(z.string())),
    openaiAppsChallengeToken: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      ipAllowlist: "ip_allowlist",
      openaiAppsChallengeToken: "openai_apps_challenge_token",
    });
  }),
);

export function updateDomainRequestBodyToJSON(
  updateDomainRequestBody: UpdateDomainRequestBody,
): string {
  return JSON.stringify(
    UpdateDomainRequestBody$outboundSchema.parse(updateDomainRequestBody),
  );
}
